/**
 * The Levenshtein distance is a measure of the difference between two strings.
 * It is defined as the minimum number of single-character edits (insertions, deletions or substitutions)
 * required to change one string into the other. It is also sometimes referred to as edit distance,
 * although that may also refer to different distance metrics.
 * @param s first word
 * @param t second word
 * @returns number
 */

export const levenshteinDistance = (s: string, t: string): number => {
    if (!s.length) return t.length;
    if (!t.length) return s.length;
    const arr = [];
    for (let i = 0; i <= t.length; i++) {
      arr[i] = [i];
      for (let j = 1; j <= s.length; j++) {
        arr[i][j] =
          i === 0
            ? j
            : Math.min(
                arr[i - 1][j] + 1,
                arr[i][j - 1] + 1,
                arr[i - 1][j - 1] + (s[j - 1] === t[i - 1] ? 0 : 1)
              );
      }
    }
    return arr[t.length][s.length];
  };
  